import ReportOverviewContent from './ReportOverviewContent';
import { ReportOverviewWrapper, ReportOverviewSection } from './ReportOverview.styles';

interface ReportOverviewProps {
  isLoading: boolean;
}

const ReportOverview = (props: ReportOverviewProps): JSX.Element => {
  const { isLoading } = props;

  if (isLoading) {
    return <div />;
  }

  return (
    <ReportOverviewWrapper>
      <ReportOverviewSection>
        <ReportOverviewContent showTitle={true} />
      </ReportOverviewSection>
    </ReportOverviewWrapper>
  );
};

export default ReportOverview;
